module.exports = __webpack_public_path__ + "static/media/images.4de2873c.svg";